import { useEffect, useState } from "react";

const navLinks = [
  { href: "#rates", label: "稿费单价" },
  { href: "#value", label: "收益构成" },
  { href: "#flow", label: "投稿流程" },
  { href: "#faq", label: "常见问题" },
  { href: "#subscribe", label: "关注指南" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled || open
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200/80 shadow-card"
          : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex h-16 w-full max-w-7xl items-center justify-between px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2" aria-label="回到顶部">
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-lg text-background-50">
            <i className="ri-empathize-line" aria-hidden="true"></i>
          </span>
          <span className="font-display text-xl text-foreground-950">吃瓜投稿攻略</span>
        </a>

        <div className="hidden items-center gap-1 md:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-200/70 hover:text-foreground-950"
            >
              {link.label}
            </a>
          ))}
        </div>

        <div className="hidden items-center gap-2 md:flex">
          <a
            href="#value"
            className="whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            看看能赚多少
          </a>
        </div>

        <button
          className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-lg text-xl text-foreground-800 hover:bg-background-200/70 md:hidden"
          onClick={() => setOpen((v) => !v)}
          aria-label={open ? "关闭菜单" : "打开菜单"}
          aria-expanded={open}
        >
          <i className={open ? "ri-close-line" : "ri-menu-line"} aria-hidden="true"></i>
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200/80 bg-background-50/95 px-4 pb-5 pt-2 backdrop-blur-md md:hidden">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={() => setOpen(false)}
              className="block rounded-xl px-3 py-3 text-base font-medium text-foreground-800 hover:bg-background-200/70"
            >
              {link.label}
            </a>
          ))}
          <a
            href="#value"
            onClick={() => setOpen(false)}
            className="mt-3 block whitespace-nowrap rounded-full bg-primary-500 px-5 py-3 text-center text-base font-semibold text-background-50"
          >
            看看能赚多少
          </a>
        </div>
      )}
    </header>
  );
}